import {
  OPEN_HAMBURGER_MENU,
  OPEN_SEARCHBAR,
  MEMBER_UPDATED,
  IS_OPEN_LOGIN_FORM,
  MOVIE_LIST_OK,
  RADIOT_CLICKED,
  RADIOT_HELSINKI,
  RADIOT_YLEISOHJELMA,
  RADIOT_KAJANI,
  RADIOT_KEMI,
  RADIOT_TORNIO,
  RADIOT_KOKKOLA,
  RADIOT_KRISTIINANKAUPPUNKI,
  RADIOT_TURKU,
  RADIOT_OULU,
  RADIOT_ROVANIEMI,
  RADIOT_LAHTI,
  RESET_ALL_RADIO_PLAYERS,
} from "./actions";

function hamburgerMenuReducer(state = false, action) {
  switch (action.type) {
    case OPEN_HAMBURGER_MENU:
      return action.isHamburgerMenuOpen;
    default:
      return state;
  }
}
function radiotReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_CLICKED:
      return action.isRadiotClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotHelsinkiReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_HELSINKI:
      return action.isRadiotHelsinkiClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotYleisohjelmaReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_YLEISOHJELMA:
      return action.isRadiotYleisohjelmaClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotKananiReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_KAJANI:
      return action.isRadiotKajaniClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotKemiReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_KEMI:
      return action.isRadiotKemiClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotTornioReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_TORNIO:
      return action.isRadiotTornioClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotKokkolaReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_KOKKOLA:
      return action.isRadiotKokkolaClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotKristiinankauppunkiReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_KRISTIINANKAUPPUNKI:
      return action.isRadiotKristiinankauppunkiClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotTurkuReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_TURKU:
      return action.isRadiotTurkuClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotOuluReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_OULU:
      return action.isRadiotOuluClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotRovaniemiReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_ROVANIEMI:
      return action.isRadiotRovaniemiClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}
function radiotLahtiReducer(state = false, action) {
  switch (action.type) {
    case RADIOT_LAHTI:
      return action.isRadiotLahtiClicked;
    case RESET_ALL_RADIO_PLAYERS:
      return false;
    default:
      return state;
  }
}


function searchBarReducer(state = false, action) {
  switch (action.type) {
    case OPEN_SEARCHBAR:
      return action.isSearchBarOpen;
    default:
      return state;
  }
}

function memberReducer(state = null, action) {
  switch (action.type) {
    case MEMBER_UPDATED:
      return action.member;

    default:
      return state;
  }
}

function loginReducer(state = false, action) {
  switch (action.type) {
    case IS_OPEN_LOGIN_FORM:
      return action.payload;
    default:
      return state;
  }
}

const userIntialState = {
  jwt_token: null,
};

function userReducer(state = userIntialState, action) {
  switch (action.type) {
    case "METYPE_JWT_TOKEN":
      return {
        ...state,
        jwt_token: action.payload,
      };

    default:
      return state;
  }
}
const dataIntialState = {
  movieList: [],
};
function movieReducer(state = dataIntialState, action) {
  switch (action.type) {
    case MOVIE_LIST_OK:
      return {
        ...state,
        movieList: action.payload,
      };

    default:
      return state;
  }
}

export const REDUCERS = {
  isHamburgerMenuOpen: hamburgerMenuReducer,
  isSearchBarOpen: searchBarReducer,
  member: memberReducer,
  isLoginOpen: loginReducer,
  userReducer: userReducer,
  movieReducer: movieReducer,
  isRadiotClicked: radiotReducer,
  isRadiotHelsinkiClicked: radiotHelsinkiReducer,
  isRadiotYleisohjelmaClicked: radiotYleisohjelmaReducer,
  isRadiotKajaniClicked: radiotKananiReducer,
  isRadiotKemiClicked: radiotKemiReducer,
  isRadiotTornioClicked: radiotTornioReducer,
  isRadiotKokkolaClicked: radiotKokkolaReducer,
  isRadiotKristiinankauppunkiClicked: radiotKristiinankauppunkiReducer,
  isRadiotTurkuClicked: radiotTurkuReducer,
  isRadiotOuluClicked: radiotOuluReducer,
  isRadiotRovaniemiClicked: radiotRovaniemiReducer,
  isRadiotLahtiClicked: radiotLahtiReducer,
};
